import { Order, OrderFields } from 'types/order'
import { groupOrders } from './group-orders'

export class NewClientSorter {
  static sort(orders: Order[]) {
    const [newClientOrders, regularOrders] = groupOrders(orders, NewClientSorter.isNewClientOrder)

    return [...newClientOrders, ...regularOrders]
  }

  static isNewClientOrder(order: Order): boolean {
    return order[OrderFields.INTERNAL_META]?.fromNewClient === true
  }
}
